<template>
  <a-modal
    title="预售许可证"
    :width="800"
    :visible="visible"
    :confirmLoading="loading"
    @ok="
      () => {
        $emit('ok')
      }
    "
    @cancel="
      () => {
        $emit('cancel')
      }
    "
  >
    <a-spin :spinning="loading">
      <a-form :form="form" v-bind="formLayout">
        <a-form-item label="许可证号">
          <a-input
            v-decorator="[
              'code',
              {
                rules: [
                  { required: true, message: '请输入许可证号！' },
                  { max: 20, message: '长度不能大于20' }
                ]
              }
            ]"
          />
        </a-form-item>
        <a-form-item label="发证时间">
          <a-date-picker
            style="width: 100%"
            v-decorator="['date', { rules: [{ required: true, message: '请选择发证时间' }] }]"
          />
        </a-form-item>
        <a-form-item label="绑定楼栋">
          <a-input
            v-decorator="[
              'building',
              {
                rules: [
                  { required: true, message: '请输入绑定楼栋！' },
                  { max: 20, message: '长度不能大于20' }
                ]
              }
            ]"
          />
        </a-form-item>
        <a-form-item
          label="上传图片"
          extra="支持扩展名：.jpg, .jpeg, .png"
          :labelCol="{ lg: { span: 7 }, sm: { span: 15 } }"
          :wrapperCol="{ lg: { span: 12 }, sm: { span: 17 } }"
        >
          <uploadOss :media="media" :visible="previewVisible" :maxLength="1" @emitFiles="getFileList"></uploadOss>
        </a-form-item>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
import pick from 'lodash.pick'
import { UploadOss } from '@/components'

// 表单字段
const fields = ['code', 'date', 'building']

export default {
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      default: () => false
    },
    model: {
      type: Object,
      default: () => null
    },
    media: {
      type: Array,
      default: () => []
    }
  },
  components: {
    UploadOss
  },
  data() {
    return {
      form: this.$form.createForm(this),
      // 文件上传
      previewVisible: false
    }
  },
  methods: {
    getFileList(data) {
      // this.media = data
      this.$emit('emitMedia', data)
    }
  },
  created() {
    // 防止表单未注册
    fields.forEach(v => this.form.getFieldDecorator(v))

    // 当 model 发生改变时，为表单设置值
    this.$watch('model', () => {
      this.model && this.form.setFieldsValue(pick(this.model, fields))
    })
  }
}
</script>
